import React, { useRef, useState, useEffect } from "react";
import { createPortal } from "react-dom";
import Recaptcha from "react-google-recaptcha";
import usePublicConfig from "storefront/hooks/usePublicConfig";
import styles from "./index.module.scss";

type Execute = () => void;
type Reset = () => void;
type Props = {
  onChange: (value: string | null | undefined) => void;
  children: (functions: { execute: Execute; reset: Reset }) => React.ReactNode;
};

const InvisibleRecaptcha = ({ onChange, children }: Props) => {
  const recaptchaRef = useRef<Recaptcha>(null);
  const [portalTarget, setPortalTarget] = useState<Element | null>(null);
  const publicConfig = usePublicConfig();
  const siteKey = publicConfig?.recaptcha?.siteKeyInvisible || "";

  useEffect(() => {
    setPortalTarget(document.body);
  }, []);

  const execute: Execute = () => {
    if (siteKey === "") {
      onChange(null);
    } else if (recaptchaRef.current) {
      recaptchaRef.current.execute();
    }
  };

  const reset: Reset = () => {
    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
    }
  };

  return (
    <>
      {/* Portal to body so the badge escapes ModalV2's transform-based stacking context */}
      {siteKey !== "" && portalTarget
        ? createPortal(
            <Recaptcha
              className={styles.recaptcha}
              sitekey={siteKey}
              ref={recaptchaRef}
              onChange={onChange}
              size="invisible"
            />,
            portalTarget,
          )
        : null}
      {children({
        execute,
        reset,
      })}
    </>
  );
};

export default InvisibleRecaptcha;
